import * as CONFIGS from '@/statics/configs.js';

const NODE2 = {
  NAME: 'S2LT-SSR1',
  INPUT1: {
    NAME: 'NODE2_INPUT1_NAME',
    TYPE: 'zeroContact',
    ICON: 'switch',
    PARAMETER_ID: 0x8020,
  },
  INPUT2: {
    NAME: 'NODE2_INPUT2_NAME',
    TYPE: 'zeroContact',
    ICON: 'switch',
    PARAMETER_ID: 0x8021,
  },
  OUTPUT1: {
    NAME: 'NODE2_OUTPUT1_NAME',
    TYPE: 'RelaySSR2A',
    ICON: 'lamp',
    PARAMETER_ID: 0xE010,
  },
  OUTPUT2: {
    NAME: 'NODE2_OUTPUT2_NAME',
    TYPE: 'RelaySSR2A',
    ICON: 'lamp',
    PARAMETER_ID: 0xE011,
  },
  TEMPERATURE: {
    NAME: 'NODE2_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xE110,
  },
  RELAY2_INIT: {
    PARAMETER_ID: 0xE111,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
}
NODE2.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: 24688,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: 24689,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE2.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: 24688,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE2.INPUT2.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: 24689,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
]

export default NODE2;